const NAMESPACE = "testConnection";

const KEYS = {
    connectionNameLabel: "connectionNameLabel",
    inputPropertiesTitle: "inputPropertiesTitle",
    perConfigurationInputPropertiesTitle: "perConfigurationInputPropertiesTitle",
    dynamicFieldNameInputLabel: "dynamicFieldNameInputLabel",
    dynamicFieldValueInputLabel: "dynamicFieldValueInputLabel",
    savePropertiesButtonLabel: "savePropertiesButtonLabel",
    callConnectionButtonLabel: "callConnectionButtonLabel",
    statusMessageLabel: "statusMessageLabel",
    statusDetailLabel: "statusDetailLabel",
    statusWaitingLabel: "statusWaitingLabel",
    requestMessageLabel: "requestMessageLabel",
    responseMessageLabel: "responseMessageLabel",
    closeButtonLabel: "closeButtonLabel",
    unsavedChangesLabel: "unsavedChangesLabel",
    savingLabel: "savingLabel",
    savedLabel: "savedLabel",
    duplicateNameValidationError: "duplicateNameValidationError",
    defaultUserLabel: "defaultUserLabel",
    programAdminWarning: "programAdminWarning",
    cprAdminWarning: "cprAdminWarning",
    requestFieldsTitle: "requestFieldsTitle",
    responseFieldsTitle: "responseFieldsTitle",
    dynamicRequestFieldsLabel: "dynamicRequestFieldsLabel",
    dynamicResponseFieldsLabel: "dynamicResponseFieldsLabel",
    addDynamicRequestFieldButtonLabel: "addDynamicRequestFieldButtonLabel",
    httpMethodLabel: "httpMethodLabel",
    payloadTypeLabel: "payloadTypeLabel",
    pathParametersTitle: "pathParametersTitle",
    httpMethodQueryParameterText: "httpMethodQueryParameterText",
    requestUrlLabel: "requestUrlLabel",
    payloadIndicatorText: "payloadIndicatorText",
    queryParamIndicatorText: "queryParamIndicatorText",
    multiInstanceElementPlaceholder: "multiInstanceElementPlaceholder"
};

const MESSAGES = {
    [KEYS.connectionNameLabel]: {
        value: "Connection Name: ",
        comment: "label for name of connection"
    },
    [KEYS.inputPropertiesTitle]: {
        value: "Input Properties",
        comment: "Title for list of Input Properties"
    },
    [KEYS.perConfigurationInputPropertiesTitle]: {
        value: "Per-Configuration Input Properties",
        comment: "Title for list of Per-Configuration Input Properties"
    },
    [KEYS.dynamicFieldNameInputLabel]: {
        value: "Dynamic Field Name",
        comment: "Label for the Dynamic Field Name input"
    },
    [KEYS.dynamicFieldValueInputLabel]: {
        value: "Dynamic Field Value",
        comment: "Label for the Dynamic Field Value input"
    },
    [KEYS.savePropertiesButtonLabel]: {
        value: "Save Properties",
        comment: "button label"
    },
    [KEYS.callConnectionButtonLabel]: {
        value: "Call Connection",
        comment: "button label"
    },
    [KEYS.statusMessageLabel]: {
        value: "Status: ",
        comment: "label for error message"
    },
    [KEYS.statusDetailLabel]: {
        value: "Detail: ",
        comment: "label for error message details"
    },
    [KEYS.statusWaitingLabel]: {
        value: "Waiting...",
        comment: "status label shown when waiting for Connection to complete"
    },
    [KEYS.requestMessageLabel]: {
        value: "Request Message",
        comment: "text area label"
    },
    [KEYS.responseMessageLabel]: {
        value: "Response Message",
        comment: "text area label"
    },
    [KEYS.closeButtonLabel]: {
        value: "Close",
        comment: "button label"
    },
    [KEYS.unsavedChangesLabel]: {
        value: "Unsaved Changes",
        comment: "saved status indicator label"
    },
    [KEYS.savingLabel]: {
        value: "Saving ...",
        comment: "saved status indicator label"
    },
    [KEYS.savedLabel]: {
        value: "Saved",
        comment: "saved status indicator label"
    },
    [KEYS.duplicateNameValidationError]: {
        value: "This name is already being used.",
        comment: "Error message for using a duplicate name"
    },
    [KEYS.defaultUserLabel]: {
        value: "(none)",
        comment: "Label for (none) in the user selector."
    },
    [KEYS.programAdminWarning]: {
        value: 'Clicking "Call Connection" will make an API call to an external service, and will utilize the test endpoint if configured. There may be unexpected effects of making this API call without being connected to a PowerClerk project.',
        comment: "Text for the warning shown to program admins testing custom web adapters."
    },
    [KEYS.cprAdminWarning]: {
        value: 'Clicking "Call Connection" will make an API call to a customer\'s web service! Please ensure that all keys and credentials are correct, and avoid agressively retrying failed requests so as not to be disruptive or suspicious.',
        comment: "Text for the warning shown to CPR admins testing custom web adapters."
    },
    [KEYS.requestFieldsTitle]: {
        value: "Request Fields",
        comment: "title for list of request fields"
    },
    [KEYS.responseFieldsTitle]: {
        value: "Response Fields",
        comment: "title for list of response fields"
    },
    [KEYS.dynamicRequestFieldsLabel]: {
        value: "Dynamic Request Fields",
        comment: "Title for the Dynamic Request Fields section"
    },
    [KEYS.dynamicResponseFieldsLabel]: {
        value: "Dynamic Response Fields",
        comment: "Title for the Dynamic Response Fields section"
    },
    [KEYS.addDynamicRequestFieldButtonLabel]: {
        value: "Add Dynamic Request Field",
        comment: "Label for the Add Dynamic Request Field button"
    },
    [KEYS.httpMethodLabel]: {
        value: "HTTP Method",
        comment: "dropdown label for HTTP method"
    },
    [KEYS.payloadTypeLabel]: {
        value: "Payload Type",
        comment: "dropdown label for payload type"
    },
    [KEYS.pathParametersTitle]: {
        value: "Path Parameters",
        comment: "title for list of path parameters"
    },
    [KEYS.httpMethodQueryParameterText]: {
        value: 'When HTTP method is GET or DELETE, request fields are included in the request as query parameters, and the request does not have a body. When "Fields and Project Information" is selected for message version on the Test Connection page, GET and DELETE requests will only include request fields.',
        comment: "text explaining how request fields for specific HTTP methods are included in the request"
    },
    [KEYS.requestUrlLabel]: {
        value: "Request URL",
        comment: "title for the input field showing the url of the request in the test connection"
    },
    [KEYS.payloadIndicatorText]: {
        value: " (payload)",
        comment: "text to indicate that a field in the test connection is going to be included in the payload"
    },
    [KEYS.queryParamIndicatorText]: {
        value: " (query parameter)",
        comment: "text to indicate that a field in the test connection is going to be include in the query parameters"
    },
    [KEYS.multiInstanceElementPlaceholder]: {
        value: "Empty element",
        comment: "Placeholder for the response field key path input shown when value is null or empty string"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
